<template>
    <div class="flex__around tab-bar">
        <div class="flex__center__between" v-for="(item,index) in tab_bar.list" :key="index" @click="switchTab(index)">
            <span class="jcicon fs_48" :class="[item.icon,current==index?tab_bar.selectedColor:tab_bar.color]"></span>
            <span class="fs_20" :class="current==index?tab_bar.selectedColor:tab_bar.color">{{item.text}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name:'TabBar',
    data(){
        return{
            tab_bar: {
                "color": "c_98",
                "selectedColor": "c_main",
                list: [
                {
                    "path": "/Mall/Index",
                    "text": "首页",
                    "icon": "jcicon-shouye1"
                },
                {
                    "path": "/Mall/Category/0",
                    "text": "分类",
                    "icon": "jcicon-fenlei_huaban"
                },
                {
                    "path": "/Mall/Cart",
                    "text": "购物车",
                    "icon": "jcicon-gouwuche2"
                },
                {
                    "path": "/Mine/Index",
                    "text": "我的",
                    "icon": "jcicon-wode"
                }
                ]
            }
        }
    },
    props: {
        current:{
            type: Number
        }
    },
    methods:{
        switchTab(index){
            this.tab_bar.current=index;
            this.$router.push(this.tab_bar.list[index].path);
        }
    }
}
</script>
<style scoped>
.tab-bar{
    position: fixed;
    bottom: 0;
    z-index:999;
    width: 100%;
    height: 98px;
    padding: 10px 0;
    background: #fff;
    border-top: 2px solid #e6e6e6;
}
</style>





// WEBPACK FOOTER //
// src/pages/mall/TabBar.vue